import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment-timezone";
import LocaleStrings from "Languages";
import Button from "react-bootstrap-button-loader";
import DayPicker, { DateUtils } from "react-day-picker";
import Helmet from "react-helmet";
import { Row, Col } from "react-bootstrap";
import { DATE_FORMAT, itemCount, converDateIntoLocalDate } from "Constants";
import NoContent, { NO_BILLING } from "NoContent";
import Pagination from "react-js-pagination";
import { fetchBillingInfo } from "SettingActions";
import ExportBailingExcelBtn from "./downloadbillingcsv.js";
import DetailsInfoUserItem from "./billinginfo-activeuser-item";
var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class BillingDetails extends Component {
  static defaultProps = {
    numberOfMonths: 2,
  };
  constructor(props) {
    super(props);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    //this.state            = this.getInitialState();
    this.state = {
      from: moment().subtract(30, "day").endOf("day").toDate(),
      to: moment().toDate(),
      loading: true,
      desc: LocaleStrings.settings_billing_details_preparing_list,
      loader: false,
      pageNumber: 1,
      activeLoader: false,
      showPicker: false,
    };
  }

  componentDidMount() {
    // For Billing Info Table LIST

    this.props.fetchBillingInfo(
      this.props.session,
      0,
      0,
      moment(this.state.from).format(DATE_FORMAT),
      moment(this.state.to).format(DATE_FORMAT),
      (CallBackResponse) => {
        this.setState({ loading: false });
      }
    );
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  // Arrow function for render Sponsors Insights menu divs
  callFunction = () => {
    this.paginationCallback(this.state.pageNumber);
  };

  // Intialstate
  // getInitialState() {
  //     return {
  //     from: moment().subtract(30, "day").endOf("day").toDate(),
  //     to: moment().toDate(),
  //     loading: true,
  //     desc: LocaleStrings.gamification_text_preparing_analytics,
  //     loader: false,
  //     pageNumber: 1,
  //     activeLoader: false,
  //     };
  // }

  toggleCalendar = () => {
    if (!this.state.showPicker) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({
      showPicker: !prevState.showPicker,
    }));
  };

  handleOutsideClick = (e) => {
    // if (!this.node.contains(e.target)) this.toggleCalendar();
  };

  handleDayClick(day) {
    const range = DateUtils.addDayToRange(day, this.state);

    this.setState(range);

    if (typeof range.from !== "undefined" && typeof range.to !== "undefined") {
      this.setState({ from: range.from });
      this.setState({ to: range.to });
      // Toggle Calendar
      this.toggleCalendar();

      var myFromdate = moment(range.from).format(DATE_FORMAT);
      var myUptodate = moment(range.to).format(DATE_FORMAT);

      this.setState({ loading: true });
      this.props.fetchBillingInfo(
        this.props.session,
        0,
        0,
        myFromdate,
        myUptodate,
        (CallBackResponse) => {
          this.setState({ loading: false });
        }
      );
    }
  }

  handleResetClick() {
    //this.setState(this.getInitialState());
    this.setState({ pageNumber: 1 });
    this.setState({ from: moment().subtract(30, "day").endOf("day").toDate() });
    this.setState({ to: moment().toDate() });

    var myFromdate = moment(
      moment().subtract(30, "day").endOf("day").toDate()
    ).format(DATE_FORMAT);
    var myUptodate = moment(moment().toDate()).format(DATE_FORMAT);

    this.setState({ loading: true });
    this.props.fetchBillingInfo(
      this.props.session,
      0,
      0,
      myFromdate,
      myUptodate,
      (CallBackResponse) => {
        this.setState({ loading: false });
      }
    );
  }

  exportBills = (JSONData, ShowLabel) => {
    this.JSONToCSVConvertor(JSONData, ShowLabel);
  };

  JSONToCSVConvertor(JSONData, ShowLabel) {
    var XLSX = require("xlsx");
    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();
    _.map(JSONData, (item, index) => {
      /* Create a worksheet */
      var ws = XLSX.utils.json_to_sheet(item);
      // var ws1 = XLSX.utils.json_to_sheet(JSONData['F2(149426)']);

      var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars
      if (sheetName.length > 30) {
        sheetName = sheetName.substr(0, 28) + "...";
      }

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      // XLSX.utils.book_append_sheet(wb, ws1, "F2(149426)");
    });

    /* Generate xlsx files */
    XLSX.writeFile(wb, "billing_details.xlsx");
  }

  paginationCallback = (pageNumber) => {
    //   this.props.fetchLeaderboardUserList(
    //     this.props.session,
    //     pageNumber,
    //     0,
    //     (response) => {

    //     }
    //   );

    this.props.fetchBillingInfo(
      this.props.session,
      pageNumber,
      0,
      moment(this.state.from).format(DATE_FORMAT),
      moment(this.state.to).format(DATE_FORMAT),
      (CallBackResponse) => {
        this.setState({ loading: false });
      }
    );

    this.setState({ ...this.state, pageNumber });
  };

  renderUserList() {
    let pageDataLength = this.props.activeUsrsDetails.data.length;

    let { pageNumber } = this.state;

    return _.map(this.props.activeUsrsDetails.data, (appUser, index) => {
      return (
        <DetailsInfoUserItem
          key={appUser.Username}
          appUser={appUser}
          position={index}
          pagination={this.paginationCallback}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
        />
      );
    });
  }

  render() {
    var { session, deviceSize, activeUsrsDetails } = this.props;
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    let userStateCount =
      activeUsrsDetails && activeUsrsDetails.data
        ? activeUsrsDetails.data.length
        : 0;

    return (
      <div className="panel noborder-panel">
        <div className="panel-header">
          <div className="pull-left h-100 vertical-align-center">
            <div>
              <div className="custom-text1-primary-medium">
                {LocaleStrings.setting_submenu_title7}
              </div>
              <div className="custom-text2-secondary-normal">
                {LocaleStrings.setting_submenu_description7}
              </div>
            </div>
          </div>
          <div className="pull-right h-100 vertical-align-center"></div>
        </div>
        <div className="clearfix" />
        {/* Header */}
        <div className="sticky" style={{ borderTop: "1px solid #fafafa" }}>
          <div className="content-header-bar">
            <div className="pull-left h-100 vertical-align-center">
              <div className="custom-text1-primary-medium">
                {LocaleStrings.settings_billing_details_header}
              </div>
              <div className="bill-stng-userstate-box">
                <span className="custom-text1-primary">{userStateCount}</span>
              </div>
            </div>
            <div className="pull-right h-100 vertical-align-center">
              <ul className="header-buttons vertical-align-center">
                <li>
                  {this.state.showPicker ? (
                    <button
                      className="i-custom-table-delete"
                      style={{ color: "red" }}
                      onClick={this.toggleCalendar}
                    >
                      <img
                        className="i-custom-table"
                        src="../../style/images/custom-icons/shape-1317-copy-3.svg"
                      />
                    </button>
                  ) : (
                    <Button
                      id="analytics_datepicket_btn"
                      variant={this.state.showPicker ? "danger" : "primary"}
                      onClick={this.toggleCalendar}
                    >
                      <i
                        className={
                          this.state.showPicker
                            ? "fa fa-times"
                            : "fa fa-calendar"
                        }
                      ></i>
                    </Button>
                  )}
                </li>

                <li>
                  <div>
                    <div
                      style={{
                        color: "#2676ea",
                        fontWeight: "bold",
                        display: "inline-block",
                      }}
                    >
                      {from ? converDateIntoLocalDate(from) : ""}
                    </div>
                    <div style={{ display: "inline-block", margin: "5px" }}>
                      {" "}
                      ➔{" "}
                    </div>
                    <div
                      style={{
                        color: "#2676ea",
                        fontWeight: "bold",
                        display: "inline-block",
                      }}
                    >
                      {from ? converDateIntoLocalDate(to) : ""}
                    </div>
                  </div>
                </li>

                <li
                  ref={(node) => {
                    this.node = node;
                  }}
                >
                  <div>
                    {this.state.showPicker ? (
                      <div className="RangeExample">
                        {!from && !to && "Please select the first day."}
                        {from && !to && "Please select the last day."}
                        {from && to && (
                          <Row className="vertical-align-center">
                            <Col md={3}>
                              {" "}
                              {from && to && (
                                <button
                                  className="link extra-button-theme btn-custom-white"
                                  onClick={this.handleResetClick}
                                >
                                  {LocaleStrings.reset}
                                </button>
                              )}
                            </Col>
                          </Row>
                        )}

                        <DayPicker
                          className="Selectable"
                          numberOfMonths={this.props.numberOfMonths}
                          selectedDays={[from, { from, to }]}
                          modifiers={modifiers}
                          onDayClick={this.handleDayClick}
                          shouldCloseOnSelect={true}
                          onChange={(value) => {
                            this.refs.timePicker.cancelFocusInput();
                          }}
                        />
                        <Helmet>
                          <style>{`
                                                    .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                                                        background-color: #f0f8ff !important;
                                                        color: #4a90e2;
                                                    }
                                                    .Selectable .DayPicker-Day {
                                                        border-radius: 0 !important;
                                                    }
                                                    .Selectable .DayPicker-Day--start {
                                                        border-top-left-radius: 50% !important;
                                                        border-bottom-left-radius: 50% !important;
                                                    }
                                                    .Selectable .DayPicker-Day--end {
                                                        border-top-right-radius: 50% !important;
                                                        border-bottom-right-radius: 50% !important;
                                                    }
                                                    `}</style>
                        </Helmet>
                      </div>
                    ) : null}
                  </div>
                </li>
                <li>
                  <ExportBailingExcelBtn
                    startDt={moment(this.state.from).format(DATE_FORMAT)}
                    endDt={moment(this.state.to).format(DATE_FORMAT)}
                    JSONToCSVConvertor={this.exportBills}
                  />
                </li>
              </ul>
            </div>
          </div>
          <br />
          <Helmet>
            <style>{`
                                .Range .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                                    background-color: #f0f8ff !important;
                                    color: #4a90e2;
                                }
                                .Range .DayPicker-Day {
                                    border-radius: 0 !important;
                                }
                                .DayPicker {
                                    right:1px;  
                                    width:560px;
                                    display: block;
                                    font-size: 1.5rem;
                                    position: absolute;
                                    background: white;
                                    z-index: 1000;
                                    margin-top: 35px;
                                    border-radius: 10px;
                                    -webkit-box-shadow: 0 1px 15px 1px rgba(40,72,229,.2)!important;
                                    box-shadow: 0 1px 15px 1px rgba(40,72,229,.2)!important;
                                }
                                .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                                    background-color: #f0f8ff !important;
                                    color: #4a90e2;
                                }
                                .Selectable .DayPicker-Day {
                                    border-radius: 0 !important;
                                }
                                .Selectable .DayPicker-Day--start {
                                    border-top-left-radius: 50% !important;
                                    border-bottom-left-radius: 50% !important;
                                }
                                .Selectable .DayPicker-Day--end {
                                    border-top-right-radius: 50% !important;
                                    border-bottom-right-radius: 50% !important;
                                }
                                .DayPicker-Day--highlighted{
                                    color:#4da1ff;
                                    font-weight:bold;

                                }
                            `}</style>
          </Helmet>
        </div>
        <div
          className="panel-body scrollable-content"
          // style={{
          //     height: deviceSize.height - 138,
          // }}
        >
          {/* Table */}

          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <div className={this.state.activeLoader ? "user_main_div" : ""}>
              <div
                className="panel-body scrollable-content"
                // style={{ height: deviceSize.height - 175 }}
              >
                {this.props.activeUsrsDetails.data &&
                this.props.activeUsrsDetails.data.length > 0 ? (
                  <div className="">
                    <table className="table">
                      <thead>
                        <tr>
                          <th align="center">
                            {LocaleStrings.settings_billing_details_table_th1}
                          </th>
                          <th align="center">
                            {LocaleStrings.settings_billing_details_table_th2}
                          </th>
                          <th align="center">
                            {LocaleStrings.settings_billing_details_table_th3}
                          </th>
                        </tr>
                      </thead>
                      <tbody className="tbody-background">
                        {this.renderUserList()}
                      </tbody>
                    </table>
                    {this.props.activeUsrsDetails &&
                    this.props.activeUsrsDetails.count > itemCount ? (
                      <Pagination
                        activePage={this.state.pageNumber}
                        itemsCountPerPage={itemCount}
                        totalItemsCount={this.props.activeUsrsDetails.count}
                        pageRangeDisplayed={10}
                        onChange={this.paginationCallback}
                        style={{ float: "right" }}
                      />
                    ) : null}
                  </div>
                ) : (
                  <NoContent contentType={NO_BILLING} />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

// function mapStateToProps(state) {
//   return {
//     session: state.session,
//     deviceSize: state.deviceSize,
//     activeUsrsDetails:state.activeUsrsDetails,
//   };
// }

function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    activeUsrsDetails: state.activeUsrsDetails,
  };
}

export default connect(mapStateToProps, { fetchBillingInfo })(BillingDetails);
